import { api } from "@/api/axios.ts";
import { ApiFolder } from "@/types/document.types.ts";

export const apiEmployeeDocument = {
  getAllFolders(employeeId: number, signal: AbortSignal) {
    return api.get<ApiFolder[]>(
      `/api/v1/employees/${employeeId}/documents/folders`,
      undefined,
      signal
    );
  },
};
